import { SET_INITIALIZED, SET_COOKIE } from "../actionTypes/appActionTypes";

const defaultState = {
  initialized: false,
  cookieExisted: false,
};

export default function appReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_INITIALIZED:
      return {
        ...state,
        initialized: action.payload,
      };
    case SET_COOKIE:
      return {
        ...state,
        cookieExisted: action.payload,
      };
    default:
      return state;
  }
}
